(function () {
  'use strict';

  function initMethodDrawer() {
    var body = document.body;
    var drawer = document.getElementById('MethodMobileMenu');
    var overlay = document.querySelector('.mp-drawer-overlay');

    if (!body || !drawer || drawer.dataset.mpEnhanced === 'true') return;
    drawer.dataset.mpEnhanced = 'true';

    var openers = Array.prototype.slice.call(document.querySelectorAll('[data-mp-menu-open]'));
    var closeButton = drawer.querySelector('[data-mp-menu-close]');
    var toggles = Array.prototype.slice.call(drawer.querySelectorAll('[data-mp-submenu-toggle]'));
    var lastTrigger = null;

    function setSubmenuState(toggle, isOpen) {
      var submenu = toggle.nextElementSibling;
      if (!submenu || !submenu.classList.contains('mp-submenu')) return;

      toggle.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      submenu.classList.toggle('is-open', isOpen);
      submenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

      if (isOpen) {
        submenu.removeAttribute('inert');
      } else {
        submenu.setAttribute('inert', '');
      }
    }

    function closeOtherSubmenus(activeToggle) {
      toggles.forEach(function (toggle) {
        if (toggle !== activeToggle) setSubmenuState(toggle, false);
      });
    }

    function openDrawer(trigger) {
      if (trigger) lastTrigger = trigger;
      body.classList.add('mp-menu-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.setAttribute('aria-hidden', 'false');
      openers.forEach(function (opener) { opener.setAttribute('aria-expanded', 'true'); });

      window.requestAnimationFrame(function () {
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    }

    function closeDrawer(returnFocus) {
      body.classList.remove('mp-menu-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.setAttribute('aria-hidden', 'true');
      openers.forEach(function (opener) { opener.setAttribute('aria-expanded', 'false'); });
      toggles.forEach(function (toggle) { setSubmenuState(toggle, false); });

      if (returnFocus !== false && lastTrigger && document.contains(lastTrigger)) {
        window.requestAnimationFrame(function () {
          lastTrigger.focus({ preventScroll: true });
        });
      }
    }

    function syncSubmenu(toggle) {
      var submenu = toggle.nextElementSibling;
      var isOpen = Boolean(submenu && submenu.classList.contains('is-open'));
      if (isOpen) closeOtherSubmenus(toggle);
      setSubmenuState(toggle, isOpen);
    }

    function getFocusableItems() {
      return Array.prototype.slice.call(
        drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (item) {
        return !item.closest('[inert]') && item.getClientRects().length > 0;
      });
    }

    openers.forEach(function (opener) {
      opener.setAttribute('aria-controls', 'MethodMobileMenu');
      opener.setAttribute('aria-expanded', 'false');
    });

    toggles.forEach(function (toggle) {
      setSubmenuState(toggle, false);
    });

    if (overlay) overlay.setAttribute('aria-hidden', 'true');

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-mp-menu-open]');
      var closer = event.target.closest('[data-mp-menu-close]');
      var toggle = event.target.closest('#MethodMobileMenu [data-mp-submenu-toggle]');
      var drawerLink = event.target.closest('#MethodMobileMenu a[href]');

      if (opener) {
        window.requestAnimationFrame(function () { openDrawer(opener); });
        return;
      }

      if (closer) {
        window.requestAnimationFrame(function () { closeDrawer(true); });
        return;
      }

      if (toggle) {
        window.requestAnimationFrame(function () { syncSubmenu(toggle); });
        return;
      }

      if (drawerLink) {
        window.requestAnimationFrame(function () { closeDrawer(false); });
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (!body.classList.contains('mp-menu-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer(true);
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusableItems();
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }, true);

    window.addEventListener('resize', function () {
      if (window.innerWidth > 989 && body.classList.contains('mp-menu-open')) {
        closeDrawer(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMethodDrawer);
  } else {
    initMethodDrawer();
  }
})();
